import type { Site } from '@/api/fe-api/domain/entities/site';
import { SiteOperationalPhase as OperationalPhase } from '@/api/fe-api/domain/entities/site-operational-phase';
import { cls } from '@/utils/cls';

const operationalPhasesFromCurrent: Record<
  OperationalPhase,
  [OperationalPhase, 'done' | 'current' | 'upcoming'][]
> = {
  [OperationalPhase.PLANNING]: [
    [OperationalPhase.PLANNING, 'current'],
    [OperationalPhase.COMMISSIONING, 'upcoming'],
    [OperationalPhase.IN_OPERATION, 'upcoming'],
  ],
  [OperationalPhase.COMMISSIONING]: [
    [OperationalPhase.PLANNING, 'done'],
    [OperationalPhase.COMMISSIONING, 'current'],
    [OperationalPhase.IN_OPERATION, 'upcoming'],
  ],
  [OperationalPhase.IN_OPERATION]: [
    [OperationalPhase.PLANNING, 'done'],
    [OperationalPhase.COMMISSIONING, 'done'],
    [OperationalPhase.IN_OPERATION, 'current'],
  ],
  [OperationalPhase.MONITORING_ENDED]: [
    [OperationalPhase.MONITORING_ENDED, 'current'],
  ],
  [OperationalPhase.END_OF_LIFE]: [
    [OperationalPhase.PLANNING, 'done'],
    [OperationalPhase.COMMISSIONING, 'done'],
    [OperationalPhase.IN_OPERATION, 'done'],
    [OperationalPhase.END_OF_LIFE, 'current'],
  ],
};

type TooltipContentProps = {
  site: Site;
};

export function TooltipContent({ site }: TooltipContentProps) {
  const phases = operationalPhasesFromCurrent[site.operationalPhase];

  return (
    <ol className="mx-2 my-1 flex list-none flex-col gap-3">
      {phases.map(([phase, status]) => (
        <li
          key={phase}
          className={cls('text-white/75', {
            'font-semibold text-white/100': status === 'current',
          })}
        >
          {phase}
        </li>
      ))}
    </ol>
  );
}
